/**
 * The mark: a trail blaze — the two painted rectangles that tell a hiker the
 * route turns here. A language of instruction rather than allegiance.
 *
 * Two rects. Nothing else. No third rect, no shield, no badge frame, no outline,
 * shadow, gradient or bevel, and no rotation or motion (spec §1, misuse).
 *
 * The colour rule in one line: **the upper rect is ember in every context** —
 * light, dark, print, embroidery. Only the lower rect follows the surface. That
 * is why the mark never washes out on a dark screen.
 */
interface MarkProps {
  /** Rendered size in px. The geometry is defined on a 48x48 grid. */
  size?: number;
  /** Both rects in one colour. Permitted for single-colour contexts only. */
  monochrome?: boolean;
  className?: string;
  /** Set when a sibling element already names the brand, to avoid a double read. */
  decorative?: boolean;
}

export function Mark({ size = 32, monochrome = false, className, decorative = false }: MarkProps) {
  const lower = monochrome ? 'currentColor' : 'var(--color-brand-ink)';
  const upper = monochrome ? 'currentColor' : 'var(--color-brand-mark)';

  return (
    <svg
      viewBox="0 0 48 48"
      width={size}
      height={size}
      className={className}
      role={decorative ? undefined : 'img'}
      aria-label={decorative ? undefined : 'TroopHerald'}
      aria-hidden={decorative || undefined}
      focusable="false"
    >
      <rect x="9" y="20" width="19" height="22" rx="3" fill={lower} />
      <rect x="20" y="5" width="19" height="11" rx="3" fill={upper} />
    </svg>
  );
}
